import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NurseNotesApi } from '../api/nurse-notes.api';
import { switchMap, map } from 'rxjs/operators';

import { NurseNotes,NurseNotesData } from '../../../interfaces/Ip/nurse-notes';

@Injectable()
export class NurseNotesService extends NurseNotesData {
 
  constructor(private api:NurseNotesApi) {
    super();  
   }
   list(url: string): Observable<NurseNotes[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<NurseNotes>{
      return this.api.getById(url); 
  }

  create(url: string, data:NurseNotes): Observable<NurseNotes> {
    return this.api.add(url,data);
  }
  update(url: string, data:NurseNotes): Observable<NurseNotes> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
